import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Stack, StackProps, Typography } from '@mui/material';

interface Props extends StackProps {
  title?: string;
}

export const EmptyTreatmentConsultationList: React.FC<Props> = ({
  title = 'Esse pet ainda não possui nenhum registro de consulta realizada.',
}) => {
  return (
    <Stack spacing={1} flex={1} justifyContent="center" alignItems="center">
      <InfoOutlinedIcon />
      <Typography fontWeight={400} color="#4B4B4B">
        {title}
      </Typography>
    </Stack>
  );
};
